export const INTAKE_SITE_STAGING = 'datad0g.com'
export const INTAKE_SITE_US1 = 'datadoghq.com'
export const INTAKE_SITE_US1_FED = 'ddog-gov.com'



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-core/src/domain/configuration/intakeSites.ts